module.exports = __webpack_public_path__ + "static/media/eth.51325e6d.svg";